import {SlugRegistry} from '@/domainproject/registry';

export class Color {
  readonly $_paramName: string;

  constructor(readonly $_name: string, readonly $_hex: string) {
    this.$_paramName = $_name.toLowerCase();
  }

  serialize(): any {
    return this.$_paramName;
  }
}

const blue = new Color('Blue', '#7ad9ff');
const pink = new Color('Pink', '#FF80F3');
const green = new Color('Green', '#40F77B');
const orange = new Color('Orange', '#F7AC40');
const yellow = new Color('Yellow', '#F7F640');

export const $_COLORS = new SlugRegistry(
  [blue, pink, green, orange, yellow],
  x => x.$_paramName
);
